import { createActions, createReducer, resettableReducer } from 'reduxsauce';
import { combineReducers } from 'redux';

import { types as loginTypes } from '../auth/login';

export const { Types: types, Creators: actions } = createActions(
  {
    getCustomerSavings: ['customerId'],
    getCustomerSavingsRequest: [],
    getCustomerSavingsSuccess: ['data'],
    getCustomerSavingsFailure: ['error'],
  },
  { prefix: 'cb/customerSavings/' },
);

export const INITIAL_STATE = {
  fetching: false,
  fetched: false,
  data: {},
  error: null,
};

export default resettableReducer(loginTypes.LOGOUT)(
  combineReducers({
    fetching: createReducer(INITIAL_STATE.fetching, {
      [types.GET_CUSTOMER_SAVINGS_REQUEST]: () => true,
      [types.GET_CUSTOMER_SAVINGS_SUCCESS]: () => INITIAL_STATE.fetching,
      [types.GET_CUSTOMER_SAVINGS_FAILURE]: () => INITIAL_STATE.fetching,
    }),
    fetched: createReducer(INITIAL_STATE.fetched, {
      [types.GET_CUSTOMER_SAVINGS_SUCCESS]: () => true,
      [types.GET_CUSTOMER_SAVINGS_FAILURE]: () => true,
    }),
    data: createReducer(INITIAL_STATE.data, {
      [types.GET_CUSTOMER_SAVINGS_SUCCESS]: (_, { data }) => data,
    }),
    error: createReducer(INITIAL_STATE.error, {
      [types.GET_CUSTOMER_SAVINGS_REQUEST]: () => INITIAL_STATE.error,
      [types.GET_CUSTOMER_SAVINGS_FAILURE]: (_, { error }) => error,
    }),
  }),
);